import { useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Custom hook to set page title using the site title from theme settings
 * @param {string} pageTitle - The specific page name (e.g., "Dashboard", "Login")
 */
const usePageTitle = (pageTitle) => {
  const { adminTheme } = useTheme();

  useEffect(() => {
    const siteTitle = adminTheme?.sidebar?.siteTitle || 'Trados — The Trusted Trade Platform';
    
    if (pageTitle) {
      document.title = `${pageTitle} | ${siteTitle}`;
    } else {
      document.title = siteTitle;
    }

    // Cleanup: reset to site title when component unmounts
    return () => {
      document.title = siteTitle;
    };
  }, [pageTitle, adminTheme]);
};

export default usePageTitle;
